<template>
  <transition name="fade" appear>
    <a :class="{ 'alternate-theme': alternateTheme }" v-if="external || link[0] === '#'" :href="link">
      <span>{{ text }}</span>
    </a>
    <button :class="{ 'alternate-theme': alternateTheme }" v-else>
      <span>{{ text }}</span>
    </button>
  </transition>
</template>

<script>
  export default {
    name: "Button",
    props: {
      text: String,
      link: String,
      alternateTheme: Boolean,
      external: Boolean,
    },
  };
</script>

<style lang="scss" scoped>

  a,
  button {
    border:none;
    text-decoration: none;
    padding: 20px 20px 22px 20px;
    border-radius: 4px;
    background: var(--light-green);
    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(10px);
    overflow: hidden;
    display: inline-block;
    line-height: 0;
    text-transform: uppercase;
    cursor: pointer;

    &.alternate-theme {    
      background: var(--white);
      text-transform: uppercase;
      span {
        color:var(--black);
      }
      &:before {
        background: #EFB21E;
      }
    }

    &.book {
      padding: 8px 16px;
    }

    span {
      position: relative;
      color: var(--white);
      font-family: "proxima-nova", sans-serif;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 0.84px;
    }

    &:before {
      content: "";
      transition: 0.2s all ease-in-out;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: var(--white);
      transform:translateY(100%);
    }

    
    &.disabled {
      pointer-events: none;
    }
    &.selected {
      pointer-events: none;      
    }

    @media (hover: hover) {
      &:not(.disabled) {
        &:hover {
          &:before {
            transform:translateY(0%);
          }
        }
      }
    }
  }
</style>